/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileMpg = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M21.266 11.887c.21 0 .42.019.627.055a3 3 0 0 1 .593.165v.912a4.215 4.215 0 0 0-.628-.152 3.194 3.194 0 0 0-.551-.049c-.53 0-.937.14-1.222.421-.28.276-.42.675-.42 1.195 0 .579.121 1.014.365 1.303.249.285.626.428 1.132.428.193 0 .382-.011.565-.034.024-.003.047-.009.07-.012v-.97l-.85-.28v-.58h1.857v2.463a3.636 3.636 0 0 1-1.076.304 4.196 4.196 0 0 1-.594.04c-.846 0-1.488-.225-1.925-.676-.432-.45-.648-1.113-.648-1.986 0-.539.105-.996.317-1.374.216-.381.525-.672.925-.87.405-.202.892-.303 1.463-.303zm-10.534 3.401 1.572-3.305h1.125V17h-1.063v-3.249l-1.325 2.766h-.662l-1.325-2.723V17H8.013v-5.017h1.124zm5.469-3.305c.616 0 1.081.143 1.394.428.317.285.475.709.475 1.27 0 .372-.071.685-.214.938a1.327 1.327 0 0 1-.628.566c-.275.13-.618.194-1.027.194h-.724V17h-1.07v-5.017zm-.724 2.519h.503c.368 0 .628-.062.78-.187.156-.128.234-.34.234-.634 0-.3-.078-.511-.234-.635-.152-.124-.412-.186-.78-.186h-.503z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileMpg as FileMpg };
